import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ICON_INNER = {
    // memory — Brain (Lucide) : 2 hémisphères courbes (ancien memoire)
    memory: (_jsxs(_Fragment, { children: [_jsx("path", { d: "M9 3a4 4 0 0 1 4 4v1a4 4 0 0 1-1 2.65A4 4 0 0 1 13 13v1a4 4 0 0 1-4 4 4 4 0 0 1-4-4v-1a4 4 0 0 1 1-2.65A4 4 0 0 1 5 8V7a4 4 0 0 1 4-4Z" }), _jsx("path", { d: "M15 3a4 4 0 0 0-2 .55" }), _jsx("path", { d: "M19 8v1a4 4 0 0 1-1 2.65A4 4 0 0 1 19 14v1a4 4 0 0 1-4 4" })] })),
    // attention — Target : 3 cercles concentriques
    attention: (_jsxs(_Fragment, { children: [_jsx("circle", { cx: "12", cy: "12", r: "2" }), _jsx("circle", { cx: "12", cy: "12", r: "6" }), _jsx("circle", { cx: "12", cy: "12", r: "10" })] })),
    // executive — Globe + meridiens (réutilise ancien logique : domaine de
    // contrôle, raisonnement, flexibilité — cohérence visuelle preserved)
    executive: (_jsxs(_Fragment, { children: [_jsx("circle", { cx: "12", cy: "12", r: "10" }), _jsx("path", { d: "M12 2a14.5 14.5 0 0 0 0 20" }), _jsx("path", { d: "M2 12h20" })] })),
    // speed — Zap/lightning : éclair (ancien vivacite)
    speed: (_jsx(_Fragment, { children: _jsx("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" }) })),
    // language — Type/T : caractère typographique
    language: (_jsxs(_Fragment, { children: [_jsx("polyline", { points: "4 7 4 4 20 4 20 7" }), _jsx("line", { x1: "9", y1: "20", x2: "15", y2: "20" }), _jsx("line", { x1: "12", y1: "4", x2: "12", y2: "20" })] })),
    // social — Users : 2 silhouettes
    social: (_jsxs(_Fragment, { children: [_jsx("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }), _jsx("circle", { cx: "9", cy: "7", r: "4" }), _jsx("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }), _jsx("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })] })),
    // perception (pending M5+) — Eye : œil + pupille (Lucide eye)
    perception: (_jsxs(_Fragment, { children: [_jsx("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" }), _jsx("circle", { cx: "12", cy: "12", r: "3" })] })),
    // motor (pending hors scope solo, DEC-017) — Activity / pulse line
    motor: (_jsx(_Fragment, { children: _jsx("polyline", { points: "22 12 18 12 15 21 9 3 6 12 2 12" }) })),
};
const INNER_SIZE = {
    36: 16,
    48: 22,
    80: 44,
};
export function CategoryIcon({ slug, size = 48, dimmed = false, className = '' }) {
    const innerPx = INNER_SIZE[size];
    return (_jsx("span", { "aria-hidden": true, style: {
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: 'rgba(45,90,138,0.05)',
            opacity: dimmed ? 0.35 : 1,
        }, className: `
        inline-flex shrink-0 items-center justify-center
        border border-cyan-border-faint
        ${className}
      `, children: _jsx("svg", { width: innerPx, height: innerPx, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round", className: "text-cyan-network", children: ICON_INNER[slug] }) }));
}
//# sourceMappingURL=CategoryIcon.js.map